import { Card, CardContent, CardFooter } from "./ui/card";
import { WorkspaceSearchItem } from "~/.server/api/routers/workspace";
import { Link } from "@remix-run/react";
import { Badge } from "./ui/badge";
import { getImageUrl } from "~/utils/misc";
import { Image } from "./image";
import { urlPattern } from "~/utils/urlPattern";
import { Star } from "lucide-react";
import { cn } from "~/lib/utils";

export function WorkspaceCard({ category, slug, image, title, city, citySlug, countryCode, priceMin, isSubscribed, currency }: WorkspaceSearchItem) {
  const formatPrice = (price: number | null, currency: string) => {
    if (price === null) return null;
    
    try {
      return new Intl.NumberFormat('es', {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(price);
    } catch (error) {
      // Fallback formatting if the currency is invalid
      return `${price} ${currency}`;
    }
  };
  return (
    <Link 
      to={urlPattern.build({ 
        category,
        city: citySlug,
        space: slug,
      })}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Card
        data-testid="workspace-card"
        className={cn(
          "overflow-hidden h-full relative",
          isSubscribed && "ring-2 ring-amber-400/80 shadow-md"
        )}
      >
        {isSubscribed && (
          <Badge
            className="absolute top-2 right-2 z-10 gap-1 bg-amber-400 text-amber-950 hover:bg-amber-400"
          >
            <Star className="h-3 w-3 fill-current" aria-hidden />
            Destacado
          </Badge>
        )}
        <CardContent className="p-0">
          <Image
            src={getImageUrl(image?.slug, '300x200')}
            alt={title}
            className="w-full h-48 object-cover"
            rotation={image?.transforms?.rotation || 0}
          />
        </CardContent>
        <CardFooter className="flex flex-col items-start p-4">
          <h3 className="text-sm font-semibold line-clamp-2">{title}</h3>
          <p className="text-sm text-muted-foreground">{city}, {countryCode}</p>
          {priceMin ? <p className="text-sm">Desde {formatPrice(priceMin, currency)}</p> : null }
        </CardFooter>
      </Card>
    </Link>
  )
}

export default function WorkspaceGrid({ spaces = [] }: { spaces: WorkspaceSearchItem[] }) {
  return (
    <section className="w-full py-12">
      <div className="max-w-[2000px] mx-auto">
        {/* <h2 className="text-2xl font-bold mb-6">Espacios destacados</h2> */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
          {spaces.map((space) => (
            <WorkspaceCard key={space.id} {...space} />
          ))}
        </div>
      </div>
    </section>
  )
}
